import { CompletedTaskCustomData } from '../../datapoints';
import now from 'owa-datetime/lib/userDate/now';
import selectTodoById from '../../selectors/selectTodoById';

export default function getCompletedTaskCustomData(todoId: string): CompletedTaskCustomData {
    return {
        differenceFromDueDate: getDifferenceFromDueDate(todoId),
        differenceFromReminderDate: getDifferenceFromReminderDate(todoId),
    };
}

function getDifferenceFromDueDate(todoId: string): number {
    const item = selectTodoById(todoId);

    if (!item) {
        return null;
    }

    const dueDate = item.DueDateTime;
    return dueDate ? dueDate.getTime() - now().getTime() : null;
}

function getDifferenceFromReminderDate(todoId: string): number {
    const item = selectTodoById(todoId);

    if (!item) {
        return null;
    }
    const reminderDate = item.ReminderDateTime;
    return reminderDate ? reminderDate.getTime() - now().getTime() : null;
}
